<template lang="pug">
  .waiter-judgement-switch.mx-auto(@click.stop="onSwitch()")
    input(type="checkbox" v-model="_value")
    label.switch-label()
      span
    .switch-img
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 待機者の評価中／評価済を切り替えるスイッチ
 */
@Component
export default class WaiterJudgementSwitch extends Vue {
  @Prop({
    default: () => {
      return false;
    }
  })
  value!: boolean;

  get _value(): boolean {
    return this.value;
  }

  public onSwitch(): void {
    this.$emit("input", !this.value);
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";

.waiter-judgement-switch {
  line-height: 26px;
  letter-spacing: 0;
  text-align: center;
  position: relative;
  width: 68px;

  // チェックボックス
  input[type="checkbox"] {
    display: none;
  }

  // リンクであることが分かるようにカーソルを変える
  cursor: pointer;

  // ラベル
  label.switch-label {
    display: block;
    box-sizing: border-box;
    height: 28px;
    border: 2px solid $switch-bordercolor;
    border-radius: 4px;
    font-size: 11px;
    background: rgba(255, 255, 255, 1);
    margin-bottom: 0;
    // リンクであることが分かるようにカーソルを変える
    cursor: pointer;
  }

  // ラベル(ON)
  input[type="checkbox"]:checked + label {
    // ON時の枠線
    border-color: $btn-selected;
  }

  // 表示する文字(OFF)
  label span:after {
    content: "評価中";
    padding: 0 0 0 20px;
    color: $switch-bordercolor;
  }

  // 表示する文字(ON)
  input[type="checkbox"]:checked + label span:after {
    content: "評価済";
    padding: 0 20px 0 0;
    color: $btn-selected;
  }

  // トグル部分
  .switch-img {
    position: absolute;
    width: 20px;
    height: 20px;
    background: $switch-bordercolor;
    top: 4px;
    left: 4px;
    border-radius: 2px;
    transition: 0.2s;
  }

  // トグル部分(ON)
  input[type="checkbox"]:checked ~ .switch-img {
    transform: translateX(40px);
    background: $btn-selected;
  }
}
</style>
